module.exports = __webpack_public_path__ + "f28cfc9669dfaced9d406499dea595a4.pdf";